import { debounce } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { TfiClose } from "react-icons/tfi";
import { MdKeyboardArrowDown } from "react-icons/md";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import NoResult from "../../../../components/NoResult";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { callEvent } from "../../../../services/main.service";
import { saveInteractionAPI } from "../../../../services/record.service";
import {
  getItemPartnerCoService,
  getCategories,
} from "../../../../services/partnerco.service";
import {
  setInteractionData,
  setShopComAllData,
} from "../../interaction.actions";
import { InteractionData } from "../../interaction.interface";
import SelectListBrand from "../selectListBrand";
import { payloadPartnerCoSite } from "./constants";
import "./style.css";
import { getBrandTheme } from "../../../../utils/brand.util";

const siteName = "partner.co";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "calc(var(--vh, 1vh) * 85)",
    width: "80%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: 0,
    backgroundColor: "#000000",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    position: "absolute" as const,
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.8)",
    zIndex: 99999,
    position: "fixed" as const,
  },
};

function InteractionPartnerCo(props: any) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { interactionData, shopSiteName, shopComAllData } = getInteractions();
  const { configurationData } = getLiveMainData();
  const { joinWithAttendeeData, createStreamData, hostTime } =
    getLiveMainData();
  const { client } = getUserData();
  const { user } = getUserData();
  const { publicUserData } = user;
  const [interactionDataArray, setInteractionDataArray] = useState<
    InteractionData[]
  >([]);
  const time = Date.now();

  const [productsDetailData, setProductsDetailData] = useState([]);
  const [productMoreData, setProductMoreData] = useState<any>([]);

  const [productsBrandTotal, setProductsBrandTotal] = useState<any>(null);
  const [productsBrandTemp, setProductsBrandTemp] = useState<any>(null);
  const [categoriesTotal, setCategoriesTotal] = useState<any>(null);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState<string[]>([]);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [payloadShopSite, setPayloadShopSite] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const childeBrandRef = useRef<any>();
  const totalItems = useRef(0);
  const isGetMoreItem = useRef(true);

  const inputRef = useRef<HTMLInputElement>(null);

  const [isDataFetched, setIsDataFetched] = useState(false);
  const { language } = getUserData();

  const scrollPositionRef = useRef(0);
  const listContainerRef = useRef<HTMLDivElement>(null);
  const listenerAddedRef = useRef(false);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  const getMoreItemRef = useRef<() => void>();
  const isMergingProductsRef = useRef(false);

  useEffect(() => {
    checkShopSite(shopSiteName);

    // Fetch categories for the dropdown next to search bar
    const locale = publicUserData?.locale;
    getCategories(locale)
      .then((resp: any) => {
        const raw = resp?.data?.categories || [];
        setCategoriesTotal(Array.isArray(raw) ? raw : []);
      })
      .catch((err: any) => {
        console.log("API PartnerCo categories error:", err);
        setCategoriesTotal([]);
      });
  }, []);

  useEffect(() => {
    if (!payloadShopSite) {
      return;
    }
    
    const isInitialLoad = !payloadShopSite?.start || payloadShopSite.start === 0;
    if (isInitialLoad) {
      setLoading(true);
    }
    setIsDataFetched(false);
    
    if (
      payloadShopSite?.start !== undefined ||
      payloadShopSite?.term ||
      payloadShopSite?.term === ""
    ) {
      getItemPartnerCoService(payloadShopSite, shopSiteName)
        .then((data: any) => {
          const item = data.data;
          totalItems.current = data.pagination.total;
          
          if (payloadShopSite?.start && payloadShopSite.start > 0) {
            isMergingProductsRef.current = true;
            setProductsDetailData((prevProducts: any[]) => {
              const isSameSearch = shopComAllData?.searchTerm ? payloadShopSite.term === shopComAllData?.searchTerm : true;
              
              if (isSameSearch && prevProducts.length > 0) {
                const newProducts = item.products || [];
                const existingIds = new Set(prevProducts.map((p: any) => p.id));
                const uniqueNewProducts = newProducts.filter((p: any) => !existingIds.has(p.id));
                const mergedProducts = [...prevProducts, ...uniqueNewProducts];
                
                const mergedData = {
                  ...item,
                  products: mergedProducts,
                  searchTerm: payloadShopSite.term,
                };
                dispatch(setShopComAllData(mergedData));
                
                requestAnimationFrame(() => {
                  isMergingProductsRef.current = false;
                });
                
                return mergedProducts;
              } else {
                const newData = {
                  ...item,
                  searchTerm: payloadShopSite.term,
                };
                dispatch(setShopComAllData(newData));
                requestAnimationFrame(() => {
                  isMergingProductsRef.current = false;
                });
                return item.products || [];
              }
            });
          } else {
            isMergingProductsRef.current = false;
            const newData = {
              ...item,
              searchTerm: payloadShopSite?.term,
            };
            dispatch(setShopComAllData(newData));
            setProductsDetailData(item.products || []);
            isGetMoreItem.current = true;
            scrollPositionRef.current = 0;
          }
          
          if (payloadShopSite?.start >= totalItems.current) {
            isGetMoreItem.current = false;
          } else {
            isGetMoreItem.current = true;
          }
          
          setProductsBrandTotal(getTrademarkOutput(item["brands"]));
          setLoading(false);
          setIsDataFetched(true);
        })
        .catch((err) => {
          console.log("API PartnerCo error:", err);
          setIsDataFetched(true);
          setLoading(false);
        });
    } else {
      setLoading(false);
      setIsDataFetched(true);
    }
  }, [payloadShopSite]);

  useEffect(() => {
    dispatch(setInteractionData(interactionDataArray));
    saveInteractionAPI(configurationData?.stream_id, interactionDataArray);
  }, [interactionDataArray]);

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionDataArray(interactionData);
    }
  }, []);

  useEffect(() => {
    const container = listContainerRef.current;

    if (!container || listenerAddedRef.current) {
      return;
    }

    listenerAddedRef.current = true;

    const handleScroll = () => {
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;
      
      if (isNearBottom) {
        setShowScrollIndicator(false);
        if (timeoutIdRef.current) {
          clearTimeout(timeoutIdRef.current);
        }
        timeoutIdRef.current = setTimeout(() => {
          if (isGetMoreItem.current && !loading && getMoreItemRef.current) {
            scrollPositionRef.current = scrollTop;
            getMoreItemRef.current();
          }
        }, 600);
      } else {
        const hasMoreItems = isGetMoreItem.current && !loading;
        setShowScrollIndicator(hasMoreItems && scrollHeight > clientHeight);
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = null;
      }
      listenerAddedRef.current = false;
    };
  }, [loading]);

  function afterOpenModal() {}

  function closeModal() {
    setSearchTerm("");
    setProductMoreData([]);
    setProductsDetailData([]);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);

    setProductsBrandTemp(null);
    setSelectedCategoryIds([]);
    setShowCategoryDropdown(false);
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
    listenerAddedRef.current = false;

    props.handleCloseMediaInteraction(false);
  }

  function handleSelectBrand() {
    setLoading(true);
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);
    if (productsBrandTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        term: searchTerm,
        brandId: productsBrandTemp?.brandId,
        categoryIds: selectedCategoryIds.join(","),
        start: 0,
      };
      getItemPartnerCoService(updatedPayload, shopSiteName)
        .then((item: any) => {
          dispatch(setShopComAllData(item));
          setLoading(false);
        })
        .catch((err) => {
          console.log("API PartnerCo error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  const handleCategoryChange = useCallback((ids: string[]) => {
    const hadSearchText = Boolean(inputRef.current?.value);
    const selectingAnyCategory = ids.length > 0;

    setSelectedCategoryIds(ids);

    if (hadSearchText && selectingAnyCategory) {
      if (inputRef.current) inputRef.current.value = "";
      setSearchTerm("");
    }

    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);

    setPayloadShopSite((prev: any) => ({
      ...prev,
      term: hadSearchText && selectingAnyCategory ? "" : (inputRef.current?.value || ""),
      start: 0,
      categoryIds: ids.join(","),
      brandId: productsBrandTemp?.brandId,
    }));
  }, [productsBrandTemp]);

  const handleFilterData = useCallback(() => {
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);
    const currentSearchTerm = inputRef.current?.value || "";
    setLoading(true);
    const updatedPayload = {
      ...payloadShopSite,
      term: currentSearchTerm,
      brandId: productsBrandTemp?.brandId,
      categoryIds: selectedCategoryIds.join(","),
      start: 0,
    };
    getItemPartnerCoService(updatedPayload, shopSiteName)
      .then((item: any) => {
        dispatch(setShopComAllData(item));
        setLoading(false);
      })
      .catch((err: any) => {
        console.log("API PartnerCo error:", err);
        setLoading(false);
      });
  }, [payloadShopSite, productsBrandTemp, selectedCategoryIds]);


  function handleSelectItem(items: any) {
    const isSelected = selectedItems?.includes(items);

    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((selectedItem: any) => selectedItem !== items)
      );
    } else {
      if (!checkElementPresentInArray(items?.id)) {
        setSelectedItems([...selectedItems, items]);
      } else {
        toast(`${items.name} ${language["already_in_interactions"]}.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  }

  function checkShopSite(site: any) {
    var locale = publicUserData?.locale;
    const initialPayload = {
      ...payloadPartnerCoSite,
      locale: locale,
      start: 0,
    };
    return setPayloadShopSite(initialPayload);
  }

  const getMoreItem = useCallback(() => {
    if (loading || !isGetMoreItem.current) {
      return;
    }
    
    setCount((prevCount: any) => {
      const newCount = prevCount + 20;
      const currentSearchTerm = inputRef.current?.value || "";
      
      if (newCount >= totalItems.current) {
        isGetMoreItem.current = false;
      }
      
      setPayloadShopSite((prevPayload: any) => ({
        ...prevPayload,
        start: newCount,
        term: currentSearchTerm,
        categoryIds: prevPayload?.categoryId || (selectedCategoryIds.join(",") || ""),
      }));
      
      return newCount;
    });
  }, [loading, selectedCategoryIds]);

  useEffect(() => {
    getMoreItemRef.current = getMoreItem;
  }, [getMoreItem]);

  useEffect(() => {
    if (productMoreData) {
      const uniqueProductIds = new Set();
      const totalProducts = []?.concat(
        ...productMoreData?.filter((arr: any) => arr !== undefined)
      );
      const uniqueProducts = totalProducts.filter((product: any) => {
        if (!uniqueProductIds.has(product.id)) {
          uniqueProductIds.add(product.id);
          return true;
        }
        return false;
      });
      setProductsDetailData([...uniqueProducts]);
    }
  }, [productMoreData]);

  useEffect(() => {
    const isInitialLoad = count === 0 || !payloadShopSite?.start || payloadShopSite.start === 0;
    
    if (isInitialLoad && shopComAllData["products"] && !isMergingProductsRef.current) {
      const uniqueProductIds = new Set();
      const uniqueProducts = shopComAllData["products"].filter((product: any) => {
        if (!uniqueProductIds.has(product.id)) {
          uniqueProductIds.add(product.id);
          return true;
        }
        return false;
      });
      setProductsDetailData(uniqueProducts);
    }

    if (count > 0 && scrollPositionRef.current > 0 && listContainerRef.current && !isMergingProductsRef.current) {
      const savedScrollPosition = scrollPositionRef.current;
      setTimeout(() => {
        if (listContainerRef.current) {
          const currentScrollHeight = listContainerRef.current.scrollHeight;
          const scrollPosition = Math.min(savedScrollPosition, currentScrollHeight - listContainerRef.current.clientHeight);
          listContainerRef.current.scrollTop = scrollPosition;
        }
      }, 50);
    }
  }, [shopComAllData, count, payloadShopSite]);

  useEffect(() => {
    if (listContainerRef.current && productsDetailData.length > 0 && !loading) {
      const container = listContainerRef.current;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;
      
      if (!isNearBottom && isGetMoreItem.current && scrollHeight > clientHeight) {
        setShowScrollIndicator(true);
      } else {
        setShowScrollIndicator(false);
      }
    } else {
      setShowScrollIndicator(false);
    }
  }, [productsDetailData, loading]);

  useEffect(() => {
    if (productsBrandTemp !== null) {
      setProductMoreData([]);
      setProductsDetailData([]);
      handleSelectBrand();
    }
  }, [productsBrandTemp]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (showCategoryDropdown && !target.closest('.category-dropdown-container')) {
        setShowCategoryDropdown(false);
      }
    };

    if (showCategoryDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCategoryDropdown]);

  const debouncedSearch = useCallback(
    debounce((searchTerm: string) => {
      setProductMoreData([]);
      setProductsDetailData([]);
      setCount(0);
      isGetMoreItem.current = true;
      scrollPositionRef.current = 0;
      setShowScrollIndicator(false);
  
      setPayloadShopSite((prev: any) => ({
        ...prev,
        term: searchTerm,
        start: 0,
        categoryIds: selectedCategoryIds.join(","),
        brandId: productsBrandTemp?.brandId,
      }));
  
      // IMPORTANT: don't call handleFilterData() here
      // payloadShopSite effect will fetch exactly once
    }, 300),
    [selectedCategoryIds, productsBrandTemp]
  );

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    setCount(0);
    debouncedSearch(newSearchTerm);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const addInteractionDataToArray = (item: any) => {
    selectedItems.forEach((item: any) => {
      var resp = createStreamData;
      if (
        resp &&
        resp["metadata"] &&
        resp["metadata"]["attendees"] &&
        resp["metadata"]["attendees"].filter(
          (p: { role: string }) => p.role == "host"
        )
      ) {
        var hostInfo = resp["metadata"]["attendees"].filter(
          (p: { role: string }) => p.role == "host"
        )[0];
        callEvent([
          {
            event_data: {
              attendee_email: hostInfo["email"],
              attendee_first: hostInfo["given_name"],
              attendee_id: hostInfo["attendee_id"],
              attendee_role: "attendee",
              attendee_last: hostInfo["family_name"] + " (host)",
              client_id: hostInfo.attendee_id.split("|")[0],
              stream_id: joinWithAttendeeData["stream_id"],
              stream_instance_id: resp["stream_instance_id"],
              user_id: hostInfo.attendee_id.split("|")[1],
              interaction_id: item?.id,
              interaction_type: "media",
              interaction_label: item?.name,
              interaction_action: item?.shopUrl,
              interaction_imageUrl: item?.imageUrl,
              elapsed_seconds: hostTime,
              date: new Date().toUTCString(),
            },
            event_type: "interaction_created",
          },
        ]);
      }
      setInteractionDataArray((prevArray) => [
        ...prevArray,
        {
          attributes: {
            action: item?.shopUrl,
            label: item?.name,
            isLinkedToStore: false,
            assetId: `${item?.opContainerId}`,
            description: item?.description,
            price:
              item?.maximumPrice != null && item?.minimumPrice != null
                ? item?.maximumPrice === item?.minimumPrice
                  ? item?.minimumPriceString
                  : `${item?.minimumPriceString}-${item?.maximumPriceString}`
                : item?.minimumPriceString || item?.maximumPriceString || "",
            createdOn: `${time}`,
            isDefault: false,
            eCommerce: false,
            shouldShow: true,
            labelVisible: true,
            thirdPartyUsername: "",
            locale: publicUserData?.locale,
            isProduct: true,
            productMaxPrice: item?.maximumPrice,
            productMinPrice: item?.minimumPrice,
            opContainerId: item?.opContainerId,
            zyiaSymbolSuffix: "",
            siteName: siteName,
            hostUserName: "",
            isMAShop: true,
            rotatable: true,
            draggable: true,
            scalable: true,
            deletable: true,
            editable: true,
            iframeable: true,
            maximumPriceString: item?.maximumPrice,
            minimumPriceString: item?.minimumPrice,
          },
          style: {
            style_type: "photo",
            pulse_animation: false,
            opacity: 1,
            thumbnail_url: item?.imageUrl,
          },
          center_x: 50,
          center_y: 50,
          rotation_angle: 0,
          start: 0,
          end: 5,
          height_max: 100,
          height_pc: 17,
          interaction_id: `${item?.opContainerId}`,
          interaction_subtype: "other",
          interaction_type: "media",
          width_max: 100,
          width_pc: 8,
          featured: false,
        },
      ]);
    });

    setSelectedItems([]);

    setTimeout(() => {
      props.handleCloseMediaInteraction(true);
    }, 200);
  };

  const checkElementPresentInArray = (id: any) => {
    return interactionDataArray.some(
      (element: any) => element.interaction_id == id
    );
  };

  function getTrademarkSymbol(trademark: any) {
    if (trademark?.includes("&reg;")) {
      return "®";
    } else if (trademark?.includes("&trade;")) {
      return "™";
    } else {
      return "";
    }
  }
  function removeHtmlEntities(str: any) {
    return str.replace(/&[^;]+;/g, "");
  }

  function getTrademarkOutput(trademarks: any) {
    return trademarks?.map((trademark: any) => {
      return {
        brandId: trademark.brandId,
        brandName:
          removeHtmlEntities(trademark.brandName) +
          getTrademarkSymbol(trademark.brandName),
      };
    });
  }

  const formatPriceRange = (
    minimumPrice: string | number | undefined,
    maximumPrice: string | number | undefined
  ) => {
    if (!minimumPrice && !maximumPrice) return "";

    const cleanMinPrice = String(minimumPrice || "")
      .replace(/^[£$€¥]/, "")
      .trim();
    const cleanMaxPrice = String(maximumPrice || "")
      .replace(/^[£$€¥]/, "")
      .trim();

    const currencyPrefix = "$";

    if (!cleanMaxPrice || cleanMinPrice === cleanMaxPrice) {
      return `${currencyPrefix}${cleanMinPrice}`;
    }

    return `${currencyPrefix}${cleanMinPrice} - ${currencyPrefix}${cleanMaxPrice}`;
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="PartnerCo Products"
    >
      <div className="flex w-full h-full bg-neutral-800 " id={"ModalInner"}>
        <div className="flex flex-col w-full bg-black  rounded-lg p-4">
          <span className="text-white text-4xl font-medium p-2">
            PartnerCo
          </span>
          <div className="w-full bg-white h-0.5 m-2" />
          <div>
            <span className="text-white p-2">
              {language["select_products_prompt"]}
            </span>
          </div>
          <div className="flex flex-row my-4 w-full" style={{ zIndex: 1 }}>
            {productsBrandTotal && productsBrandTotal.length > 0 && (
              <div>
                <SelectListBrand
                  defaultSelectedItem={{
                    brandId: "all",
                    brandName: language["select_brand"],
                  }}
                  data={productsBrandTotal}
                  onSelect={(item: any) => {
                    setProductsBrandTemp(item);
                  }}
                  ref={childeBrandRef}
                  onCloseOtherList={() => {}}
                />
              </div>
            )}

            {categoriesTotal && categoriesTotal.length > 0 && (
              <div className="ml-2 flex items-center gap-2">
                <div className="flex flex-col relative category-dropdown-container">
                  
                  <div className="relative">
                    <div
                      className={`flex flex-row bg-neutral-600 w-full pl-4 pr-4 py-4 h-12 min-w-[220px] ${
                        showCategoryDropdown ? "rounded-t-lg" : "rounded-lg"
                      } items-center cursor-pointer`}
                      onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                    >
                      <div className="flex flex-1 flex-wrap gap-1 items-center">
                        {selectedCategoryIds.length === 0 ? (
                          <span className="text-gray-300 text-sm">
                            {language["select_categories"] || "Select Categories"}
                          </span>
                        ) : selectedCategoryIds.length <= 2 ? (
                          <div className="flex flex-wrap gap-1">
                            {selectedCategoryIds.map((id) => {
                              const category = categoriesTotal.find((c: any) => c.id === id);
                              const categoryName = category?.category || category?.name || id;
                              return (
                                <span
                                  key={id}
                                  className="text-xs bg-zinc-700 text-white px-2 py-1 rounded flex items-center gap-1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const newIds = selectedCategoryIds.filter((cid) => cid !== id);
                                    handleCategoryChange(newIds);
                                  }}
                                >
                                  {categoryName}
                                  <TfiClose size={10} className="cursor-pointer hover:text-red-400" />
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-gray-300 text-sm">
                            {selectedCategoryIds.length} categories selected
                          </span>
                        )}
                      </div>
                      {showCategoryDropdown ? (
                        <MdKeyboardArrowDown className="text-gray-300 rotate-180" size={18} />
                      ) : (
                        <MdKeyboardArrowDown className="text-gray-300" size={18} />
                      )}
                    </div>
                    
                    {showCategoryDropdown && (
                      <div className="absolute top-full left-0 right-0 bg-neutral-600 rounded-b-lg border-t border-zinc-700 max-h-96 overflow-y-auto z-50">
                        <div className="p-2">
                          {categoriesTotal.map((c: any) => {
                            const isSelected = selectedCategoryIds.includes(c.id);
                            const categoryName = c.category || c.name || c.id;
                            return (
                              <div
                                key={c.id}
                                className="flex items-center p-3 hover:bg-zinc-700 cursor-pointer rounded"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  let newIds: string[];
                                  if (isSelected) {
                                    newIds = selectedCategoryIds.filter((id) => id !== c.id);
                                  } else {
                                    newIds = [...selectedCategoryIds, c.id];
                                  }
                                  handleCategoryChange(newIds);
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={(e) => {
                                    // Handle toggle here so clicking directly on the checkbox works.
                                    e.stopPropagation();
                                    let newIds: string[];
                                    if (isSelected) {
                                      newIds = selectedCategoryIds.filter((id) => id !== c.id);
                                    } else {
                                      newIds = [...selectedCategoryIds, c.id];
                                    }
                                    handleCategoryChange(newIds);
                                  }}
                                  className="mr-3 w-4 h-4 cursor-pointer"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    accentColor: getBrandTheme(client).primary,
                                  }}
                                />
                                <span className="text-gray-300 text-sm flex-1">{categoryName}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {selectedCategoryIds.length > 0 && (
                  <button
                    type="button"
                    className="bg-black text-white border-2 border-zinc-700 rounded-lg px-4 h-12 hover:bg-zinc-800 transition-colors"
                    onClick={() => {
                      setSelectedCategoryIds([]);
                      setCount(0);
                      isGetMoreItem.current = true;
                      scrollPositionRef.current = 0;
                      setShowScrollIndicator(false);

                      setPayloadShopSite((prev: any) => ({
                        ...prev,
                        start: 0,
                        categoryIds: "",
                        brandId: productsBrandTemp?.brandId,
                        term: inputRef.current?.value || "",
                      }));
                    }}
                  >
                    Clear
                  </button>
                )}
              </div>
            )}

            <div className="flex flex-row border-2 border-zinc-700 rounded-lg ml-2 p-2 items-center justify-center search-container">
              <BiSearch fill="white" size="24" />
              <input
                className="bg-black w-52 text-white pl-2 outline-none placeholder:text-white"
                placeholder={language["search_label"]}
                onChange={handleSearch}
                ref={inputRef}
              />
            </div>

            <div className="items-center absolute right-4 top-3 ">
              <TfiClose
                onClick={closeModal}
                color="#DEDEDE"
                size={30}
                cursor="pointer"
              />
            </div>
          </div>
          <div
            id="list-container"
            ref={listContainerRef}
            className="h-full w-full overflow-y-scroll containerModal relative"
          >
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div>
              </div>
            ) : productsDetailData &&
              productsDetailData.length == 0 &&
              isDataFetched ? (
              <NoResult></NoResult>
            ) : (
              <>
                <div className="grid grid-cols-6 gap-2 ">
                  {productsDetailData?.map((item: any, index) => {
                    const isSelected = selectedItems.includes(item);

                    return (
                      <div
                        className={`flex flex-col p-2 ${
                          isSelected ? "selected-item" : ""
                        }`}
                        key={`${item?.id}-${index}`}
                        onClick={() => handleSelectItem(item)}
                      >
                        <div className="rounded-lg inset-0 w-full h-44 bg-zinc-300">
                          {isSelected && (
                            <div
                              className={`selected-indicator`}
                              style={{
                                backgroundColor: `${
                                  getBrandTheme(client).primary
                                } `,
                              }}
                            />
                          )}

                          <img
                            className="h-full w-full object-cover object-center rounded-lg"
                            src={`${item?.imageUrl}`}
                            onError={(event) => {
                              event.currentTarget.src =
                                "https://andersnoren.se/themes/koji/wp-content/themes/koji/assets/images/default-fallback-image.png";
                            }}
                            alt=""
                          />
                        </div>
                        <div className="text-white mt-2 line-clamp-2">
                          <div
                            dangerouslySetInnerHTML={{ __html: item?.name }}
                          />
                        </div>
                        <div className="text-white mt-2 line-clamp-2 text-base font-medium">
                          {item.maximumPriceString
                            ? formatPriceRange(
                                item?.minimumPriceString,
                                item?.maximumPriceString
                              )
                            : formatPriceRange(
                                item?.minimumPriceString,
                                item?.maximumPriceString
                              )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {showScrollIndicator && (
                  <div className="fixed bottom-8 right-8 z-40 pointer-events-none">
                    <div
                      className="flex flex-col items-center justify-center rounded-full p-2 shadow-lg opacity-70"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        border: `1px solid ${getBrandTheme(client).primary}`,
                      }}
                    >
                      <div className="flex flex-col items-center gap-0">
                        <MdKeyboardArrowDown 
                          className="text-white text-2xl animate-bounce" 
                          style={{ animationDelay: "0s" }}
                        />
                        <MdKeyboardArrowDown 
                          className="text-white text-2xl animate-bounce -mt-2" 
                          style={{ animationDelay: "0.1s" }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {selectedItems.length > 0 && (
                  <div
                    className={`h-12 w-64 flex items-center justify-center rounded-lg ml-[40%] cursor-pointer fixed bottom-8`}
                    onClick={() => {
                      addInteractionDataToArray(selectedItems);
                    }}
                    style={{
                      backgroundColor: `${getBrandTheme(client).primary} `,
                    }}
                  >
                    <span className="text-white text-2xl">
                      {language["add_button"]}
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default InteractionPartnerCo;


